import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';
import moment from 'moment';
import { FaUsers, FaWallet, FaBed, FaBroom, FaCalendarAlt } from 'react-icons/fa';

function Dashboard() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState();
    const [bookedrooms, setbookedrooms] = useState(0);
    const [availablerooms, setavailablerooms] = useState(0);
    const [cleaningrooms, setcleaningrooms] = useState(0);
    const [allrooms, setallrooms] = useState(0);

    const [todayCount, settodayCount] = useState(0);
    const [tommCount, settommCount] = useState(0);
    const [thisMonth, setthisMonth] = useState(0);
    const [nextMonth, setnextMonth] = useState(0);

    const [todayCount1, settodayCount1] = useState(0);
    const [tommCount1, settommCount1] = useState(0);
    const [thisMonth1, setthisMonth1] = useState(0);
    const [nextMonth1, setnextMonth1] = useState(0);

    const [whatsappCount, setwhatsappCount] = useState(0);
    const [countPaid, setcountPaid] = useState(0);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1();
        });
    }, [userData]);

    const fetchData1 = async () => {
        try {
            if (!userData) return;

            const today = moment().format('YYYY-MM-DD');
            const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
            const firstDateOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const lastDateOfMonth = moment().endOf('month').format('YYYY-MM-DD');
            const firstDayOfNextMonth = moment().add(1, 'months').startOf('month').format('YYYY-MM-DD');
            const lastDayOfNextMonth = moment().add(1, 'months').endOf('month').format('YYYY-MM-DD');

            const queries = [
                query(collection(db, 'roomdetails')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Booked')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Available')),
                query(collection(db, 'roomdetails'), where('status', '==', 'Cleaning')),
                query(collection(db, 'websitebookings'), where('checkindate', '==', today), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')),
                query(collection(db, 'websitebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '==', today), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '==', tomorrow), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDateOfMonth), where('checkindate', '<=', lastDateOfMonth), where('status', '==', 'Paid')),
                query(collection(db, 'advancebookings'), where('checkindate', '>=', firstDayOfNextMonth), where('checkindate', '<=', lastDayOfNextMonth), where('status', '==', 'Paid')),
                query(collection(db, 'whatsapphistory'))
            ];

            const snapshots = await Promise.all(queries.map(q => getDocs(q)));

            setallrooms(snapshots[0].size);
            setbookedrooms(snapshots[1].size);
            setavailablerooms(snapshots[2].size);
            setcleaningrooms(snapshots[3].size);
            settodayCount(snapshots[4].size);
            settommCount(snapshots[5].size);
            setthisMonth(snapshots[6].size);
            setnextMonth(snapshots[7].size);
            settodayCount1(snapshots[8].size);
            settommCount1(snapshots[9].size);
            setthisMonth1(snapshots[10].size);
            setnextMonth1(snapshots[11].size);
            setwhatsappCount(snapshots[12].size);

            const querySnapshot = await getDocs(collection(db, 'whatsapp'));
            if (!querySnapshot.empty) {
                setcountPaid(querySnapshot.docs[0].data().countpaid);
            }
        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
            console.error(error);
        }
    };

    const boxes = [
        { count: todayCount + todayCount1, text: "Today's Bookings", icon: <FaUsers />, bg: "linear-gradient(135deg, #f54ea2, #ff7676)", link: "online-bookings/todays" },
        { count: tommCount + tommCount1, text: "Tomorrow's Bookings", icon: <FaUsers />, bg: "linear-gradient(135deg, #f7971e, #ffd200)", link: "online-bookings/tommorrows" },
        { count: thisMonth + thisMonth1, text: "This Month Bookings", icon: <FaCalendarAlt />, bg: "linear-gradient(135deg, #6a11cb, #2575fc)", link: "online-bookings/thismonth" },
        { count: nextMonth + nextMonth1, text: "Next Month Bookings", icon: <FaCalendarAlt />, bg: "linear-gradient(135deg, #43e97b, #38f9d7)", link: "online-bookings/nextmonth" },
        { count: whatsappCount - countPaid, text: "Wallet", icon: <FaWallet />, bg: "linear-gradient(135deg, #ee0979, #ff6a00)", link: "wallet" },
        { count: bookedrooms, text: "Live Bookings Rooms", icon: <FaBed />, bg: "linear-gradient(135deg, #f00000, #dc281e)", link: "live-booking-rooms" },
        { count: availablerooms, text: "Available Rooms", icon: <FaBed />, bg: "linear-gradient(135deg, #56ab2f, #a8e063)", link: "available-rooms" },
        { count: cleaningrooms, text: "Cleaning Rooms", icon: <FaBroom />, bg: "linear-gradient(135deg, #e53935, #e35d5b)", link: "cleaning-rooms" },
        { count: allrooms, text: "All Rooms", icon: <FaBed />, bg: "linear-gradient(135deg, #1e3c72, #2a5298)", link: "all-rooms" },
    ];

    return (
        <div className="d-flex">
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#f9f9f9', minHeight: '100vh', flex: 1, padding: '20px' }}>
                <section className="content">
                    <button className="btn btn-secondary mb-3">|| Dashboard ||</button>
                    <div className="row" >
                        {boxes.map((box, index) => (
                            <div key={index} className="col-lg-3 col-md-4 col-sm-6" >
                                <div className="small-box d-flex flex-column justify-content-between"
                                    style={{
                                        flex: 1,
                                        background: box.bg,
                                        color: '#fff',
                                        borderRadius: '10px',
                                        padding: '15px',
                                        minHeight: '130px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                        transition: 'transform 0.2s',
                                    }}
                                >
                                    <div className="inner d-flex align-items-center" style={{ gap: '10px' }}>
                                        <div style={{ fontSize: '2.5rem' }}>{box.icon}</div>
                                        <div>
                                            <h4 style={{ margin: 0 }}>{box.count}</h4>
                                            <p style={{ margin: 0, fontSize: '0.85rem' }}>{box.text}</p>
                                        </div>
                                    </div>
                                    <a href={box.link} style={{ color: '#fff', fontWeight: 'bold', fontSize: '0.85rem', marginTop: '5px' }}>
                                        More info <i className="fas fa-arrow-circle-right"></i>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Dashboard;
